import Select from "react-select";

const DynamicFormFields = ({
  categoryFields,
  formValues,
  handleDynamicFieldChange,
  categories,
  selectedArtist,
  selectedEventCategory
}) => {
  if (!Array.isArray(categoryFields)) return null;

  console.log(categoryFields);
  console.log(categories);
  return (
    <>
      {categoryFields.map((field, index) => {
if (field.fieldName.includes("TotalBudget")) {
    const isWeddingEntertainmentSelected = selectedEventCategory.length> 0;
  
    // If it's Wedding Entertainment, hide total budget until an artist is selected
    if (isWeddingEntertainmentSelected && !selectedArtist) {
      return null; // Hide all "Total Budget" fields
    }
  
    // If it's Wedding Entertainment, only show the matching artist's budget field
    if (isWeddingEntertainmentSelected && !field.fieldName.startsWith(selectedArtist.toUpperCase())) {
      return null; // Hide unrelated budget fields
    }
  
    // If any other category is selected, show all "Total Budget" fields
  }
  

        return (
          <div className="form-group" key={index}>
            <label>{field.fieldLabel}</label>

            {field.fieldType === "select" && (
              <select
                className="form-control"
                name={field.fieldName}
                value={formValues.dynamicFields[field.fieldName] || ""}
                onChange={(e) =>
                  handleDynamicFieldChange(field.fieldName, e.target.value)
                }
              >
                <option value="">Select</option>
                {field.options.map((option, optIndex) => (
                  <option key={optIndex} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            )}

            {field.fieldType === "multiselect" && (
              <Select
                isMulti
                name={field.fieldName}
                options={field.options.map((option) => ({
                  value: option,
                  label: option,
                }))}
                value={(formValues.dynamicFields[field.fieldName] || []).map(
                  (selectedOption) => ({
                    value: selectedOption,
                    label: selectedOption,
                  })
                )}
                onChange={(selectedOptions) => {
                  const selectedValues = selectedOptions.map(
                    (opt) => opt.value
                  );
                  handleDynamicFieldChange(field.fieldName, selectedValues);
                }}
                closeMenuOnSelect={false}
                className="basic-multiselect"
                classNamePrefix="select"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

export default DynamicFormFields;
